// All reducers from ninjas-dialog and reducers.
import { combineReducers } from 'redux';
import updateNinjas from './update-ninjas/reducers';

export default combineReducers({
  updateNinjas,
});




/** WEBPACK FOOTER **
 ** ./src/state/ui/reducers.js
 **/